import { render, staticRenderFns } from "./AmetrasMachineWorkingAreaBoundaryTemplate.vue?vue&type=template&id=afadefe0&scoped=true&"
import script from "./AmetrasMachineWorkingAreaBoundaryTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasMachineWorkingAreaBoundaryTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasMachineWorkingAreaBoundaryTemplate.vue?vue&type=style&index=0&id=afadefe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afadefe0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
